export const removeTrailingSlash = (path: string) => (path === '/' ? path : path.replace(/\/$/, ''))
